import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cd90b39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "display-flex ion-justify-content-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "display-flex ion-justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("view", null, [
    _createElementVNode("view", _hoisted_1, [
      _createVNode(_component_ion_label, { class: "empty-container-message ion-text-center" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.message), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_2,
    _createElementVNode("view", _hoisted_3, [
      _createVNode(_component_font_awesome_icon, {
        icon: _ctx.faMehBlank,
        class: "firecracker-primary-color-icon-large"
      }, null, 8, ["icon"])
    ])
  ]))
}